module.exports = __webpack_public_path__ + "static/media/宣传视频.cefdbaf5.mp4";